import { useState } from "react";
import { ReflectionType } from "../../../../../types";
import { useUrlState } from "../../hooks";
import { CategoryPage } from "./CategoryPage";
import { HomePage } from "./HomePage";
import "./index.scss";
import { ReflectionProps } from "./types";

export const Reflection = ({
  rawData,
  currentTestId,
  selectedFilters,
}: ReflectionProps) => {
  const {
    updatePath,
    path: { category },
  } = useUrlState();

  const [selectedReflectionType, setSelectedReflectionType] =
    useState<ReflectionType>(ReflectionType.Leverage);

  function navigateBackToHome() {
    updatePath({ category: undefined, cubeSide: undefined });
  }

  return (
    <div className="reflection-module">
      {category ? (
        <CategoryPage
          category={category}
          onHomeClick={navigateBackToHome}
          rawData={rawData}
          currentTestId={currentTestId}
          selectedFilters={selectedFilters}
          selectedReflectionType={selectedReflectionType}
          setSelectedReflectionType={setSelectedReflectionType}
        />
      ) : (
        <HomePage
          rawData={rawData}
          currentTestId={currentTestId}
          selectedFilters={selectedFilters}
          selectedReflectionType={selectedReflectionType}
          setSelectedReflectionType={setSelectedReflectionType}
        />
      )}
    </div>
  );
};
